// tslint:disable:max-line-length
import * as React from 'react';

import { createIcon } from '../icon';

export const ReliabilityPure = createIcon(`
  <svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="120" height="120"
    viewBox="0 0 120 120" style="enable-background:new 0 0 120 120;" xml:space="preserve">
  <style type="text/css">
    .realiability0{fill:none;stroke:#0A055F;stroke-width:2.6561;stroke-miterlimit:10;}
    .realiability1{fill:#FFFFFF;stroke:#FF4114;stroke-width:2.6561;stroke-miterlimit:10;}
    .realiability2{fill:#0A055F;}
    .realiability3{fill:none;stroke:#FF4114;stroke-width:2.6561;stroke-miterlimit:10;}
    .realiability4{fill:none;stroke:#FF4114;stroke-width:2.6561;stroke-linecap:square;stroke-miterlimit:10;}
  </style>
  <g>
    <path class="realiability0" d="M117.5,60c0,31.7-25.8,57.5-57.5,57.5S2.5,91.7,2.5,60S28.3,2.5,60,2.5S117.5,28.3,117.5,60z"/>
    <g>
      <g>
        <path class="realiability1" d="M26.9,28.4c0,0,0,13.3,0,37.4c0,28.5,33.1,37.3,33.1,37.3s33.1-8.8,33.1-37.3c0-24,0-37.4,0-37.4H26.9z"/>
        <path class="realiability0" d="M60,28.4H26.9c0,0,0,13.3,0,37.4c0,28.5,33.1,37.3,33.1,37.3"/>
        <g>
          <path class="realiability2" d="M38.3,51.7c2.7,0,4.5,1.8,4.5,4.4c0,2.6-1.8,4.4-4.5,4.4c-2.7,0-4.4-1.8-4.4-4.4
            C33.8,53.5,35.7,51.7,38.3,51.7z M38.3,58.5c1.3,0,2.1-1,2.1-2.4c0-1.4-0.8-2.4-2.1-2.4c-1.3,0-2.1,1-2.1,2.4
            S37.1,58.5,38.3,58.5z M47.3,51.9H50l-9.2,17.3H38L47.3,51.9z M49.8,60.5c2.7,0,4.5,1.8,4.5,4.4c0,2.6-1.8,4.4-4.5,4.4
            c-2.7,0-4.5-1.8-4.5-4.4C45.2,62.4,47.1,60.5,49.8,60.5z M49.8,67.4c1.3,0,2.1-1,2.1-2.4c0-1.4-0.8-2.4-2.1-2.4
            c-1.3,0-2.1,1-2.1,2.4S48.5,67.4,49.8,67.4z"/>
        </g>
        <line class="realiability3" x1="60" y1="104.2" x2="60" y2="28.4"/>
        <g>
          <line class="realiability3" x1="80.8" y1="28.4" x2="59.8" y2="46.6"/>
          <line class="realiability3" x1="92.7" y1="34.1" x2="60" y2="62.3"/>
          <line class="realiability3" x1="92.9" y1="49.8" x2="60.2" y2="78"/>
          <line class="realiability3" x1="93.1" y1="65.5" x2="60.3" y2="93.7"/>
        </g>
      </g>
      <path class="realiability4" d="M93.1,65.9c0-24,0-37.4,0-37.4H60"/>
      <path class="realiability4" d="M93.1,65.9"/>
    </g>
  </g>
  </svg>
`);

export const ReliabilityIcon: React.SFC<{ iconClassName?: string }> = (props: { iconClassName?: string }) => (
  <ReliabilityPure className={props.iconClassName} />
);

ReliabilityIcon.displayName = 'ReliabilityIcon';
